import "react";
import { isDatePickerView as a } from "./date-utils.mjs";
import { jsx as B } from "react/jsx-runtime";
import { DateCalendar as E } from "./DateCalendar.mjs";
const Q = ({
  view: o,
  onViewChange: s,
  views: n,
  focusedView: e,
  onFocusedViewChange: r,
  value: t,
  defaultValue: i,
  referenceDate: l,
  onChange: d,
  className: m,
  classes: u,
  disableFuture: h,
  disablePast: D,
  minDate: p,
  maxDate: b,
  shouldDisableDate: c,
  shouldDisableMonth: g,
  shouldDisableYear: C,
  reduceAnimations: f,
  onMonthChange: w,
  monthsPerRow: y,
  onYearChange: P,
  yearsPerRow: x,
  defaultCalendarMonth: k,
  components: F,
  componentsProps: M,
  slots: V,
  slotProps: v,
  loading: N,
  renderLoading: O,
  disableHighlightToday: W,
  readOnly: R,
  disabled: Y,
  showDaysOutsideCurrentMonth: j,
  dayOfWeekFormatter: z,
  sx: A,
  autoFocus: H,
  fixedWeekNumber: L,
  displayWeekNumber: T,
  timezone: q
}) => /* @__PURE__ */ B(E, {
  view: o,
  onViewChange: s,
  views: n.filter(a),
  focusedView: e && a(e) ? e : null,
  onFocusedViewChange: r,
  value: t,
  defaultValue: i,
  referenceDate: l,
  onChange: d,
  className: m,
  classes: u,
  disableFuture: h,
  disablePast: D,
  minDate: p,
  maxDate: b,
  shouldDisableDate: c,
  shouldDisableMonth: g,
  shouldDisableYear: C,
  reduceAnimations: f,
  onMonthChange: w,
  monthsPerRow: y,
  onYearChange: P,
  yearsPerRow: x,
  defaultCalendarMonth: k,
  components: F,
  componentsProps: M,
  slots: V,
  slotProps: v,
  loading: N,
  renderLoading: O,
  disableHighlightToday: W,
  readOnly: R,
  disabled: Y,
  showDaysOutsideCurrentMonth: j,
  dayOfWeekFormatter: z,
  sx: A,
  autoFocus: H,
  fixedWeekNumber: L,
  displayWeekNumber: T,
  timezone: q
});
export {
  Q as renderDateViewCalendar
};
//# sourceMappingURL=dateViewRenderers.mjs.map
